import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({name: 'dueDateFormat', standalone: true, pure: true})
export class DueDateFormatPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(date: Date | string | null | undefined): string {
    if (!date) return '';

    const due = new Date(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    due.setHours(0, 0, 0, 0);

    const diffDays = Math.round((due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return this.translate.instant('date.today');

    const dayUnit = this.translate.instant('date.day');
    return `${diffDays}${dayUnit}`;
  }
}
